import { render, staticRenderFns } from "./user-edit-flyout.vue?vue&type=template&id=4640b7c2&scoped=true&"
import script from "./user-edit-flyout.vue?vue&type=script&lang=js&"
export * from "./user-edit-flyout.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-flyout.vue?vue&type=style&index=0&id=4640b7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640b7c2",
  null
  
)

export default component.exports